import type { AnalyticsFilter } from './analyticsHelpers';

/**
 * react-query keys for the Social Media section.
 *
 * The whole normalised filter goes into the key, so changing the date range refetches
 * automatically -- no manual refetch() anywhere. Keys are hierarchical so one
 * invalidate on socialKeys.analytics() cascades to every chart.
 */
const root = ['social-media'] as const;

export const socialKeys = {
  all: root,

  accounts: () => [...root, 'accounts'] as const,
  account: (id: string) => [...root, 'accounts', id] as const,

  analytics: () => [...root, 'analytics'] as const,
  overview: (f: AnalyticsFilter) => [...root, 'analytics', 'overview', f] as const,
  engagement: (f: AnalyticsFilter) => [...root, 'analytics', 'engagement', f] as const,
  followers: (f: AnalyticsFilter) => [...root, 'analytics', 'followers', f] as const,
  platformComparison: (f: AnalyticsFilter) => [...root, 'analytics', 'platforms', f] as const,
  dailyMetrics: (f: AnalyticsFilter) => [...root, 'analytics', 'daily', f] as const,
  audience: (f: AnalyticsFilter) => [...root, 'analytics', 'audience', f] as const,

  content: (f: AnalyticsFilter, limit: number) => [...root, 'content', f, limit] as const,
  video: (f: AnalyticsFilter, limit: number) => [...root, 'video', f, limit] as const,
  ads: (f: AnalyticsFilter) => [...root, 'ads', f] as const,
  roi: (f: AnalyticsFilter) => [...root, 'ads', 'roi', f] as const,

  thresholds: () => [...root, 'thresholds'] as const,
} as const;
